export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f273e24954981a1041e93e69be743aa2c613cb2a3&name=fetchTypeahead!'